<template>
  <section class="forbidden-page">
    <VoodooTuneLogo class="voodootune-logo" />
    <section class="centered-wrapper">
      <div class="robots"></div>
      <img :src="illustration" alt="forbidden robots" class="illustration" />
      <h1>Forbidden</h1>
      <p class="forbidden-message">
        <span>Sorry, you don't have access to this resource.</span>
        <span v-if="shouldReload">Ask the permission to your administrator and click the reload button.</span>
        <span v-else>Please contact your administrator to give you the permission.</span>
      </p>
      <vd-button type="primary" @click="redirectToNextLocation">{{ redirectButtonLabel }}</vd-button>
      <p>
        or
        <a href="/logout">logout</a>
      </p>
    </section>
  </section>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { useRoute } from "vue-router";

import VoodooTuneLogo from "@/assets/VoodooTuneLogo.vue";
import useAuthentication from "@/hooks/use-authentication";

import illustration from "./assets/illustration-maintenance.svg";

export default defineComponent({
  name: "ForbiddenPage",
  components: {
    VoodooTuneLogo,
  },
  props: {},
  setup() {
    const route = useRoute();
    const { reload, permissions } = useAuthentication();

    const nextLocation = computed(() => (route.query.next as string) || "");

    const shouldReload = computed(() => (permissions.value || []).length === 0);

    const redirectToNextLocation = () => {
      reload(nextLocation.value);
    };

    const redirectButtonLabel = computed(() => {
      if (shouldReload.value) {
        return "Reload";
      }

      if (nextLocation.value === "/") {
        return "OK";
      }

      return "Go back";
    });

    return {
      redirectButtonLabel,
      redirectToNextLocation,
      shouldReload,
      illustration,
    };
  },
});
</script>

<style lang="scss" scoped>
.forbidden-page {
  display: grid;
  justify-items: center;
  position: absolute;
  width: 50%;
  left: 50%;
  top: 20px;
  height: 100%;
  transform: translateX(-50%);
  text-align: center;

  .voodootune-logo {
    display: inline-block;
    margin-bottom: 100px;
  }

  .centered-wrapper {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  .illustration {
    width: 350px;
    margin-bottom: 30px;
  }

  h1 {
    width: 279px;
    height: 90px;
    font-size: 40px;
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.13;
    letter-spacing: normal;
    text-align: center;

    background-color: #d3ebfc;
    color: #d3ebfc;
    text-shadow: 0px 1px 3px rgb(255, 255, 255);
    -webkit-background-clip: text;
    -moz-background-clip: text;
    background-clip: text;

    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }

  .forbidden-message {
    margin-bottom: 30px;

    span {
      display: block;
    }
  }
}
</style>
